import React, {createContext, useContext, useState} from 'react';
import {useFormik} from 'formik';
import PropTypes from 'prop-types';
import {taskTypeIDs} from '../../../../common/constants/taskTypes';
import {getTaskDetails} from "../../actions/getTaskDetails";
import {editTaskVisit, editTaskGeneral} from "../../actions/editTask";
import moment from 'moment';
import {taskStatuses} from "../../../../common/constants/options";


const PopupEditTasksContext = createContext('');

export function usePopupEditTasksContext() {
  return useContext(PopupEditTasksContext);
}

export function PopupEditTasksContextProvider({
                                                children,
                                                taskID,
                                                taskTypeID,
                                                shumaID,
                                                refreshGrid
                                              }) {
  const [taskDetails, setTaskDetails] = useState(null);

  const updateData = async () => {
    if (taskID) {
      try {
        const data = await getTaskDetails({taskID});
        setTaskDetails(data);
      } catch (e) {
        console.error(e);
        setTaskDetails(null);
      }
    }
  };

  const resetTaskDetails = (taskID) => {
    if (taskID === -1) {
      formik.resetForm();
      setTaskDetails(null);
    }
  };

  const editTask = async () => {
    try {
      if (formik.values.taskTypeID === taskTypeIDs.visit) {
        await editTaskVisit({
          taskID: formik.values.taskID,
          shumaID,
          taskStatus: formik.values.taskStatusID.value,
          dueDate: moment(formik.values.taskDueDate).format('YYYY-MM-DD'),
          notes: formik.values.notes,
          visitContactName: formik.values.visitContactName,
          visitContactPhone: formik.values.visitContactPhone
        })
        refreshGrid();
      } else {
        await editTaskGeneral({
          taskID: formik.values.taskID,
          shumaID,
          taskStatus: formik.values.taskStatusID.value,
          dueDate: moment(formik.values.taskDueDate).format('YYYY-MM-DD'),
          taskDescription: formik.values.taskDescription
        })
        refreshGrid();
      }
    } catch (e) {
      console.error(e);
    }
  }

  const [previousTaskStatusID] = taskDetails?.taskStatusID
    ? taskStatuses.filter(opt => opt.value === taskDetails?.taskStatusID) : [];

  const initialValues = {
    taskID: taskDetails?.taskID,
    taskTypeID: taskDetails?.taskTypeID,
    taskStatusID: taskDetails?.taskStatusID ? previousTaskStatusID : 1,
    taskDueDate: (taskDetails?.dueDate) ? moment(taskDetails.dueDate).toDate() : null,
    notes: taskDetails?.notes || '',
    taskDescription: taskDetails?.taskDescription || '',
    visitContactName: taskDetails?.visitContactName || '',
    visitContactPhone: taskDetails?.visitContactPhone || ''
  };

  const validate = (values) => {
    let errors = {};
    const {
      taskTypeID,
      taskStatusID,
      taskDescription,
      taskDueDate,
    } = values;

    if (!taskStatusID.value) errors[`taskStatusID`] = 'Required field';
    if (!taskDueDate) errors[`taskDueDate`] = 'Required field';

    if (taskTypeID === taskTypeIDs.general) {
      if (!taskDescription) errors[`taskDescription`] = 'Required field';
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: () => {
    },
    validate,
    validateOnMount: true,
    enableReinitialize: true,
  });

  const value = {
    taskID,
    taskTypeID,
    formik,
    updateData,
    resetTaskDetails,
    editTask,
  };

  return (
    <PopupEditTasksContext.Provider value={value}>
      {children}
    </PopupEditTasksContext.Provider>
  );
}

PopupEditTasksContextProvider.propTypes = {
  children: PropTypes.node,
};
